// Module
var code = "<div class=\"scheduler scheduler--error text-center\" data-bind=\"text: _labels.AGENDA_IS_NOT_AVAILABLE\"> </div>";
// Exports
export default code;